import React, {useContext, useEffect, useMemo} from 'react';
import { Route, Routes } from "react-router-dom";
import TermsAndConditions from './pages/TermsAndConditions';
import Checkout from "./pages/CheckoutForm";
import {PaymentInfoContext, WaitRedirectContext} from "./App";
import PaymentLinkExpireMsg from './pages/PaymentLinkExpire';

function Routers() {
  const paymentInfo = useContext(PaymentInfoContext);
  const {waitRedirect} = useContext(WaitRedirectContext);
  return (
    <Routes>
      <Route exact path="/" element={
          (paymentInfo?.paymentAllowed === false && waitRedirect === false)
              ? <PaymentLinkExpireMsg
                  paymentInfo={paymentInfo}
                  errorCode={paymentInfo.paymentMessage}
                  logoImage={paymentInfo.companyLogo}
                  transactionId={paymentInfo.transactionId}
                />
              : <Checkout />
      } />
      <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
    </Routes>
  );
}

export default Routers;
